/* global google, map*/
require('./js/markerclusterer.js')
require('./js/lodash.min.js')
var angular = require('angular')
angular.module('app').component('auiMap', {
  bindings: {
    color: '@',
    stroke: '@',
    baseUrl: '@'
  },
  template: require('./map.html'),
  controller: function ($scope, $element, $attrs, $http, ENDPOINT_SEARCH, ENDPOINT_COMPONENT, LINKS) {
    var ctrl = this

    ctrl.isDraggable = !('ontouchstart' in document.documentElement)
    ctrl.empty = false
    ctrl.places = {}
    ctrl.markers = []

    const clusterStyles = [
      {
        textColor: '#FFFFFF',
        url: ENDPOINT_COMPONENT + '/map/images/cluster.png',
        height: 37,
        width: 37,
        textSize: 13
        // backgroundPosition: [0,5]
      }
    ]

    ctrl.bounds = new google.maps.LatLngBounds()
    ctrl.map = new google.maps.Map(document.getElementById('map'), {
      center: {lat: 45.116177, lng: 7.742615},
      zoom: 5,
      maxZoom: 17,
      scrollwheel: false,
      navigationControl: true,
      mapTypeControl: false,
      draggable: ctrl.isDraggable,
      zoomControl: true,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      styles: [ { 'featureType': 'all', 'elementType': 'labels.text.fill', 'stylers': [ { 'saturation': 36 }, { 'color': '#333333' }, { 'lightness': 40 } ] }, { 'featureType': 'all', 'elementType': 'labels.text.stroke', 'stylers': [ { 'visibility': 'on' }, { 'color': '#ffffff' }, { 'lightness': 16 } ] }, { 'featureType': 'all', 'elementType': 'labels.icon', 'stylers': [ { 'visibility': 'off' } ] }, { 'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [ { 'color': '#e0e0e0' }, { 'lightness': 20 } ] }, { 'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [ { 'color': '#fefefe' }, { 'lightness': 17 }, { 'weight': 1.2 } ] }, { 'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [ { 'color': '#e0e0e0' }, { 'lightness': 20 } ] }, { 'featureType': 'poi', 'elementType': 'geometry', 'stylers': [ { 'color': '#f5f5f5' }, { 'lightness': 21 } ] }, { 'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [ { 'color': '#dedede' }, { 'lightness': 21 } ] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [ { 'color': '#ffffff' }, { 'lightness': 17 } ] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [ { 'color': '#ffffff' }, { 'lightness': 29 }, { 'weight': 0.2 } ] }, { 'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [ { 'color': '#ffffff' }, { 'lightness': 18 } ] }, { 'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [ { 'color': '#ffffff' }, { 'lightness': 16 } ] }, { 'featureType': 'transit', 'elementType': 'geometry', 'stylers': [ { 'color': '#f2f2f2' }, { 'lightness': 19 } ] }, { 'featureType': 'water', 'elementType': 'geometry', 'stylers': [ { 'color': '#e9e9e9' }, { 'lightness': 17 } ] } ]
    })
    ctrl.markerCluster = new MarkerClusterer(ctrl.map, ctrl.markers, {
      averageCenter: true,
      minimumClusterSize: 4,
      styles: clusterStyles
    })

    ctrl.input = document.getElementById('pac-input')
    ctrl.searchBox = new google.maps.places.SearchBox(ctrl.input)
    ctrl.map.controls[google.maps.ControlPosition.TOP_LEFT].push(ctrl.input)
    // ctrl.map.fitBounds(ctrl.bounds)

    ctrl.map.addListener('bounds_changed', function () {
      ctrl.searchBox.setBounds(ctrl.map.getBounds())
    })

    ctrl.searchBox.addListener('places_changed', function () {
      var places = ctrl.searchBox.getPlaces()
      var bounds = new google.maps.LatLngBounds()

      places.forEach(function (place) {
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })

      ctrl.map.fitBounds(bounds)

    })

    ctrl.$onInit = function () {

      $http.post(ENDPOINT_SEARCH, {
        'table': 'data',
        'query': {
          'table': 'ca_places',
          'georeference': {'$exists': true},
          'related': {'$exists': true, '$not': {'$size': 0}}
        },
        'fields': {
          'id': 1,
          'georeference': 1,
          'related': 1
        }
      }).then(function (result) {
        if (result.data.count > 0) {
          ctrl.result = _.get(result, 'data.data')
          ctrl.empty = false
          populateMap()
        } else {
          ctrl.empty = true
        }
      })
    }



    function populateMap () {

      let cleanResult = _.filter(ctrl.result, e => {
        var cord = _.isArray(e.georeference) ? _.head(e.georeference).cord : e.georeference.cord
        let cond1 = cord.lat !== null && cord.lon !== null
        let cond2 = _.some(
          _.chain(e.related.ca_objects)
              .values()
              .flatten()
              .filter('serie')
              .value(),
          i => i.access === '1' || i.access === '2'
        )
        return cond1 && cond2
      })

      for (var i = 0; i < cleanResult.length; i++) {
        createMarker(cleanResult[i])
      }

      ctrl.markerCluster.addMarkers(ctrl.markers, false)
      ctrl.map.fitBounds(ctrl.bounds)
      // ctrl.map.fitBounds(ctrl.markerCluster.getExtendedBounds(ctrl.bounds))
    }


    function createMarker (elm) {
      var cord = elm.georeference.cord
      ctrl.places[elm.id] = elm
      if (typeof cord !== 'undefined') {
        var image = ENDPOINT_COMPONENT + '/map/images/pin.png'
        var marker = new google.maps.Marker({
          map: ctrl.map,
          position: {lat: parseFloat(cord.lat), lng: parseFloat(cord.lon)},
          title: elm.preferred_label,
          icon: image,
          // icon: {
          //   path: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z',
          //   fillColor: ctrl.color,
          //   fillOpacity: 1,
          //   size: new google.maps.Size(71, 71),
          //   origin: new google.maps.Point(0, 0),
          //   anchor: new google.maps.Point(13, 20),
          //   strokeColor: ctrl.stroke,
          //   strokeWeight: 0.5
          // },
          id: elm.id
        })

        ctrl.bounds.extend(marker.position)
        ctrl.markers.push(marker)

        google.maps.event.addListener(marker, 'click', showInfo)
      }
    }

    function showInfo () {
      var element = ctrl.places[this.id]
      var listelem = []
      for (var table in element.related) {
        for (var typeRel in element.related[table]) {
          // items = element.related[table][typeRel]
          let items = _.filter(element.related[table][typeRel], e => e.access === '1' || e.access === '2')
          for (var i = 0; i < items.length; i++) {
            listelem.push({
              label: items[i].name + ' - ' + items[i].serie + ' (' + typeRel + ')',
              icon: 'image',
              url: ctrl.baseUrl + LINKS[table] + '/?id=arch_' + items[i].id
            })
          }
        }
      }

      var displayView = '<div><div id="siteNotice"></div><h3 id="firstHeading" class="firstHeading text-color m-top-half m-bottom">' + element.preferred_label + '</h3><hr class="hr-short-utente no-m-top m-bottom"><div id="bodyContent"><ul class="reset">'
      for (var i = 0; i < listelem.length; i++) {
        if (ctrl.view !== 'full-map') {
          displayView += '<li><a class="m-bottom d-block" href="' + listelem[i].url + '">' + listelem[i].label + '</a></li>'
        } else {
          displayView += '<li><span class="m-bottom d-block">' + listelem[i].label + '</span></li>'
        }
      }

      displayView += '</ul></div>'

      var infowindow = new google.maps.InfoWindow({
        content: displayView
      })
      infowindow.open(map, this)
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/components/map/map.js